import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { Button } from '../components/ui/Button';
import { Season2Announcement } from '../components/Season2Announcement';
import { season2Premiere } from '../data/season2Episodes';
import { SPOTIFY_SHOW_URL } from '../data/season1Episodes';
export function Season2Page() {
  return <PageTransition data-id="element-780" data-mp="xjufg68drl9z">
      <div className="pt-20 min-h-screen" data-id="element-781" data-mp="srjauq2p3bb3">
        <Season2Announcement showDetailsLink={false} data-id="element-782" data-mp="spq6jhfk1369" />

        {/* Jim's Story */}
        <section className="py-20 bg-dark-700" data-id="element-783" data-mp="oqr0tum012dr">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-784" data-mp="onbpn2vg4dhm">
            <div className="lg:col-span-7" data-id="element-785" data-mp="eriarcu987wo">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8" data-id="element-786" data-mp="eq6yspqnntuh">
                "Jim's" Story
              </h2>
              <div className="space-y-6 text-lg text-white/80 leading-relaxed" data-id="element-787" data-mp="9urmw3c7k80p">
                {season2Premiere.description.map(paragraph => <p key={paragraph.slice(0, 24)} data-id="element-788" data-mp="efq7qner1jc7">{paragraph}</p>)}
              </div>
            </div>

            {/* Journey timeline */}
            <aside className="lg:col-span-5" aria-label="Jim's journey" data-id="element-789" data-mp="4ov90jkbgr9v">
              <ol className="relative border-l border-dark-500 ml-3 space-y-10 lg:mt-20" data-id="element-790" data-mp="4p4ze899x0g3">
                {season2Premiere.journey.map((step, index) => <motion.li key={step.label} initial={{
                opacity: 0,
                x: -8
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.25,
                delay: index * 0.05,
                ease: [0.23, 1, 0.32, 1]
              }} className="pl-8" data-id="element-791" data-mp="xdsqwlkm8m23" data-mpi={index}>
                    <span className="absolute -left-[7px] mt-2 h-3.5 w-3.5 rounded-full bg-gold-500 ring-4 ring-dark-700" data-id="element-792" data-mp="3837sxf3752g5"></span>
                    <h3 className="text-2xl font-serif font-bold text-white mb-1" data-id="element-793" data-mp="19n8pafrjq79x">
                      {step.label}
                    </h3>
                    <p className="text-white/70" data-id="element-794" data-mp="14v7eyzdxuqmj">{step.detail}</p>
                  </motion.li>)}
              </ol>
            </aside>
          </div>
        </section>

        {/* CTA */}
        <section className="pb-20 bg-dark-700" data-id="element-795" data-mp="v075o6zyz4i5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-796" data-mp="qwr7v7c5yy3v">
            <div className="bg-dark-800 rounded-2xl p-8 md:p-12 text-center border border-dark-600" data-id="element-797" data-mp="qzn5svo0hmsb">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-3" data-id="element-798" data-mp="m00s6l49u4iz">
                Know someone who should be on the podcast?
              </h2>
              <p className="text-white/70 mb-8 max-w-xl mx-auto" data-id="element-799" data-mp="2gbp1a6ntncvg">
                We're booking guests for Season 2 right now. Tell us their
                story.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-800" data-mp="2ivll37e2nqe8">
                <Link to="/guests" data-id="element-801" data-mp="2nv845xgl00uy">
                  <Button rightIcon={<ArrowRight className="w-4 h-4" data-id="element-803" data-mp="2ntn5pwr5bxrt" />} data-id="element-802" data-mp="2nu5c3m7ivsdg">
                    Meet Our Guests
                  </Button>
                </Link>
                <Link to="/podcasts/season-1" data-id="element-804" data-mp="2xm2nasyj6kc6">
                  <Button variant="outline" data-id="element-805" data-mp="2xkriqqx9h8k0">Catch Up on Season 1</Button>
                </Link>
                <a href={SPOTIFY_SHOW_URL} target="_blank" rel="noopener noreferrer" data-id="element-806" data-mp="1zzltvysx4qvp">
                  <Button variant="ghost" data-id="element-807" data-mp="29vp5rwdko3vu">Follow on Spotify</Button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageTransition>;
}